interface IseiLogoProps {
  size?: number;
  className?: string;
}

/**
 * Official Isei Consulting LLC logo mark.
 * Double-hexagon seal with centered "I" monogram in gold on navy.
 * Source of truth — used site-wide.
 */
export function IseiLogo({ size = 24, className }: IseiLogoProps) {
  const c = size / 2;
  const GOLD = "#C9A356";

  const hexPoints = (cx: number, cy: number, r: number) => {
    const pts: string[] = [];
    for (let i = 0; i < 6; i++) {
      const angle = (Math.PI / 3) * i - Math.PI / 2;
      pts.push(`${cx + r * Math.cos(angle)},${cy + r * Math.sin(angle)}`);
    }
    return pts.join(" ");
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      role="img"
      aria-label="Isei Consulting"
    >
      <polygon
        points={hexPoints(c, c, size * 0.45)}
        fill="none"
        stroke={GOLD}
        strokeWidth={Math.max(1, size * 0.05)}
        strokeLinejoin="round"
      />
      <polygon
        points={hexPoints(c, c, size * 0.34)}
        fill="none"
        stroke={GOLD}
        strokeWidth={Math.max(0.75, size * 0.028)}
        opacity={0.7}
        strokeLinejoin="round"
      />
      <text
        x={c}
        y={c + size * 0.105}
        textAnchor="middle"
        fontFamily="'Cinzel', Georgia, serif"
        fontSize={size * 0.36}
        fontWeight={600}
        fill={GOLD}
        letterSpacing="0.05em"
      >
        I
      </text>
    </svg>
  );
}

export default IseiLogo;
